import {
    ALDER_LOGISK_FEILMELIND_RAD_KOLONNE,
    ALDERSGRUPPE,
    ALDERSGRUPPE_5ARIG,
    KOLONNE,
    MANED,
    RAD_EN,
    RAD_TO,
    RAD_TRE,
    UKEDAG,
    UKEDAG_MANED_FEILMELDING_RAD_KOLONNE
} from '../../ressurser/Konstanter'

/**
 * Denne funksjonen skjekker for logiske feil i rad og kolonne. Dersom en rad eller kolonne har valgt aldersgruppe eller aldersgruppe 5årig
 * vil funksjonen returnere indeksen på den andre aldersgruppe kategorien slik at nedtrekkslisten kan disable denne valgmuligheten
 * @param navn Navnet på nedtrekkslisten <br/>
 * @param valgmuligheter De tilgjenglige valgmulighetene for nedtrekkslisten <br/>
 * @param raderOgKolonnerValgETO De valgte radene og kolonnene <br/>
 * @returns {number}
 * @public
 */
export function logiskKontrollRadOgKolonner(navn, valgmuligheter, raderOgKolonnerValgETO) {
    let index = -1
    let navnVerdi = ''
    // Må finnes en bedre måte å gjøre denne switch-casen på?
    switch (navn) {
        case RAD_EN:
            navnVerdi = 'rad1'
            break
        case RAD_TO:
            navnVerdi = 'rad2'
            break
        case RAD_TRE:
            navnVerdi = 'rad3'
            break
        case KOLONNE:
            navnVerdi = 'kolonne'
            break
        default:
            break
    }
    for (const i in raderOgKolonnerValgETO) {
        if (i === navnVerdi) {
            // do nothing
        } else if (raderOgKolonnerValgETO[i]) {
            if (raderOgKolonnerValgETO[i].navn === ALDERSGRUPPE) {
                index = valgmuligheter.findIndex((element) => element && element.navn === ALDERSGRUPPE_5ARIG)
            } else if (raderOgKolonnerValgETO[i].navn === ALDERSGRUPPE_5ARIG) {
                index = valgmuligheter.findIndex((element) => element && element.navn === ALDERSGRUPPE)
            }
            if (raderOgKolonnerValgETO[i].navn === MANED) {
                index = valgmuligheter.findIndex((element) => element && element.navn === UKEDAG)
            } else if (raderOgKolonnerValgETO[i].navn === UKEDAG) {
                index = valgmuligheter.findIndex((element) => element && element.navn === MANED)
            }
        }
    }
    return index
}

/**
 * Denne funksjonen genererer en feilmelding dersom aldersgruppe eller aldersgruppe 5årig er valgt som rad eller kolonne.
 * Dette er for å informere brukeren om hvorfor valgmuligheten er blitt disablet.
 * @param verdi Verdien på valget i nedtrekksliten.
 * @returns {string}
 * @public
 */
export function genererFeilmeldingRadOgKolonne(verdi) {
    switch (verdi.navn) {
        case ALDERSGRUPPE_5ARIG:
        case ALDERSGRUPPE:
            return ALDER_LOGISK_FEILMELIND_RAD_KOLONNE
        case MANED:
        case UKEDAG:
            return UKEDAG_MANED_FEILMELDING_RAD_KOLONNE
        default:
            return ''
    }
}
